import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";

import { DataService } from "./../../data.service";
import { GUID } from "./../../guid";
import { TranslationService } from "src/app/translation.service";
import { MatDialog } from "@angular/material";

@Component({
  selector: "app-applicationnew",
  templateUrl: "./applicationnew.component.html",
  styleUrls: ["./applicationnew.component.scss"]
})
export class ApplicationNewComponent implements OnInit {
  @ViewChild("translateDialog", { static: false })
  translateDialog!: TemplateRef<any>;
  displayedColumns = ["profilename", "accessgranted", "defaultapp"];

  application: {
    label: any;
    name: any;
    description: any;
    standard: any;
    active: any;
    iconname: any;
    baseurl: any;
    sinceversionseq: any;
    deprecatedversionseq: any;
    sortorder: any;
    core: any;
  };
  appSettingsJSON: string | any[];
  fgsArray = new Array<FormGroup>();
  isLoading = false;
  isError = false;
  errorMessage = "";
  appName = "";
  mode = "New";
  nameDisabled = false;
  applicationId = "";
  guid: GUID;
  profiles: string | any[];
  languages: Array<any>;
  translatedLabels = [];
  data: any;
  dialogRef: any;
  detailForm = this.fb.group({
    name: new FormControl({ value: "", disabled: true }, Validators.required),
    label: [""],
    description: [""],
    logopath: [""],
    standard: [false],
    active: [true],
    iconname: [""],
    baseurl: [""],
    sinceversionseq: [0],
    deprecatedversionseq: [0],
    sortorder: [0],
    core: [false]
  });

  profileForm = this.fb.group({
    appsettings: this.fb.array([])
  });

  get appsettings(): FormArray {
    return this.profileForm.get("appsettings") as FormArray;
  }

  resetDetailFormControls() {
    this.detailForm.controls["label"].setValue("");
    this.detailForm.controls["name"].setValue("");
    this.detailForm.controls["description"].setValue("");
    //this.detailForm.controls['logo'].setValue('');
    this.detailForm.controls["standard"].setValue(false);
    this.detailForm.controls["active"].setValue(true);
    this.detailForm.controls["iconname"].setValue("");
    this.detailForm.controls["baseurl"].setValue("");
    this.detailForm.controls["sinceversionseq"].setValue(0);
    this.detailForm.controls["deprecatedversionseq"].setValue(0);
    this.detailForm.controls["sortorder"].setValue(0);
  }

  resetProfileFormControls() {
    const appset = this.profileForm.controls.appsettings as FormArray;
    appset.clear();
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastrService: ToastService,
    private translationService: TranslationService,
    public dialog: MatDialog
  ) {}
  translateForm: FormGroup;

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.applicationId = this.route.snapshot.params.id;
      this.appName = this.route.snapshot.params.appname;
    });

    this.guid = new GUID();

    console.log("mode", this.mode);

    if (this.mode.toLowerCase() == "new") {
      this.detailForm.controls.name.enable();
      //load profiles -> appsettings
      this.getActiveProfiles().then((res) => {
        console.log("response111111", res);
        this.profileToFormArray();
      });

      /*this.getProfileAsAppSettings().then(res => {
        console.log("response111111",res);
      });*/
    } else if (this.mode.toLowerCase() == "edit") {
      this.detailForm.controls.name.disable();

      this.getApplicationById();

      //load profiles first then merge with current appsettings
      this.getActiveProfiles().then((res) => {
        console.log("response222222", res);
        this.getAppSettingsByName().then((res) => {
          this.profileToFormArray();
        });
      });
    }
    this.translateForm = this.fb.group({
      translate: this.fb.array([]),
      code: "",
      language: ""
    });
    // Initialize with one language by default
    this.addLang();
    this.getLanguage();
    this.getTranslationLabelById();
  }

  getLanguage() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );

    this.isLoading = true;
    this.dataService
      .getOrgLanguage(organizationid, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res !== null && res.success == 1) {
            var allLanguages = res.data.orglanguage;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < allLanguages.length; i++) {
              objArr.push({
                value: allLanguages[i].code,
                label: allLanguages[i].language
              });
            }
            this.languages = objArr;

            this.isLoading = false;
          } else {
            console.log("error while deleting");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }

  selectedLanguageChange(event: { value: string; label: any }) {
    console.log("selectedLanguageChange", event);
    if (event.value.trim() != "") {
      this.translateForm.controls["code"].setValue(event.value);
      this.translateForm.controls["language"].setValue(event.label);
    } else {
      this.translateForm.controls["code"].setValue("");
      this.translateForm.controls["language"].setValue("");
    }
  }
  // languages: string[] = ["English", "es", "French", "German"];
  // selectedLanguage: string = "es";
  translatedText: string = "";

  // translateForm = new FormGroup({
  //   translate: new FormArray([
  //     new FormGroup({
  //       selectedLanguage: new FormControl(""),
  //       translatedText: new FormControl(""),
  //       // number: new FormControl(''),
  //       // email: new FormControl('')
  //     }),
  //   ]),

  // });

  translatingDialog(labelname: any): void {
    console.log("labelname", labelname);

    if (!labelname) {
      return;
    }

    this.translateForm.patchValue({ label: labelname });
    this.data = {
      labelname: labelname
    };

    this.dialogRef = this.dialog.open(this.translateDialog, {
      data: this.data,
      height: "400px",
      width: "800px"
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result) {
      }
    });
  }

  get translate(): FormArray {
    return this.translateForm.get("translate") as FormArray;
  }

  addLang() {
    const translateGroup = this.fb.group({
      languageCode: ["", Validators.required],
      translatedName: ["", Validators.required]
    });

    this.translate.push(translateGroup);
  }

  // translator() {
  //   const selectedLanguage =
  //     this.translateForm.value.translate[0].selectedLanguage;
  //   const labelname = this.data.labelname;
  //   console.log(selectedLanguage);
  //   console.log(this.translateForm.value.translate);
  //   this.translationService
  //     .translate(labelname, selectedLanguage)
  //     .subscribe((response: any) => {
  //       this.translatedText = response.data.translations[0].translatedText;
  //     });
  // }
  translator(index: number) {
    const translateGroup = this.translate.at(index) as FormGroup;
    const selectedLanguage = translateGroup.get("languageCode").value;
    const labelname = this.data.labelname;

    console.log(selectedLanguage);

    this.translationService
      .translate(labelname, selectedLanguage, "en")
      .subscribe((response: any) => {
        const translatedText = response.data.translations[0].translatedText;
        translateGroup.get("translatedName").setValue(translatedText);
      });
  }
  saveTranslated() {
    // console.log(this.translateForm);
    if (this.translateForm.valid) {
      // Handle the form submission
      console.log("Saving form data:", this.translateForm.value.translate);

      this.translatedLabels = this.translateForm.value.translate;
    }
    this.dialogRef.close();
  }
  removeLang(index: number) {
    this.translate.removeAt(index);
  }

  close() {
    this.dialogRef.close();
  }
  getTranslationLabelById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        applicationlabeltranslation: {
          applicationid: this.applicationId
        }
      }
    };

    this.isLoading = true;
    this.dataService.getApplicationTranslationLabelById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // Loop through the response and add translation fields
          if (res.data.metaapplicationlabeltranslation) {
            this.translate.clear();
            res.data.metaapplicationlabeltranslation.forEach((translation) => {
              const translateGroup = this.fb.group({
                languageCode: [translation.languagecode, Validators.required],
                translatedName: [
                  translation.translatedlabel,
                  Validators.required
                ]
              });
              this.translate.push(translateGroup);
            });
            // After populating translateForm, update translatedLabels
            this.translatedLabels =
              res.data.metaapplicationlabeltranslation.map((translation) => ({
                languageCode: translation.languagecode,
                translatedName: translation.translatedlabel
              }));

            console.log(this.translatedLabels);
          }
          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  appList() {
    this.router.navigateByUrl("home/applist");
  }

  getApplicationById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        application: {
          id: this.applicationId
        }
      }
    };

    this.isLoading = true;
    this.dataService.getApplicationById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.application = res.data.application;
          if (this.application != null) {
            this.detailForm.controls["label"].setValue(this.application.label);
            this.detailForm.controls["name"].setValue(this.application.name);
            this.detailForm.controls["description"].setValue(
              this.application.description
            );
            //this.detailForm.controls['logo'].setValue(this.application.logo);
            this.detailForm.controls["standard"].setValue(
              this.application.standard
            );
            this.detailForm.controls["active"].setValue(
              this.application.active
            );
            this.detailForm.controls["iconname"].setValue(
              this.application.iconname
            );
            this.detailForm.controls["baseurl"].setValue(
              this.application.baseurl
            );
            this.detailForm.controls["sinceversionseq"].setValue(
              this.application.sinceversionseq != null
                ? this.application.sinceversionseq
                : 0
            );
            this.detailForm.controls["deprecatedversionseq"].setValue(
              this.application.deprecatedversionseq != null
                ? this.application.deprecatedversionseq
                : 0
            );
            this.detailForm.controls["sortorder"].setValue(
              this.application.sortorder
            );
            this.detailForm.controls["core"].setValue(this.application.core);
          }
          this.isLoading = false;
        } else {
          console.log("No data");
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  getActiveProfiles() {
    return new Promise((resolve, reject) => {
      console.log("getActiveProfiles");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          profile: {
            userlicense: localStorage.getItem("crm_userlicense")
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveProfileByUserLicense(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.profiles = res.data.profiles;
            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No profile data!");
            this.errorMessage = res != null ? res.message : "No profile data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getAppSettingsByName() {
    return new Promise((resolve, reject) => {
      console.log("getAppSettingsByName");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          appsettings: {
            appname: this.appName
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getAppSettingsByName(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.appSettingsJSON = res.data.appsettings;
            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No appsettings data!");
            this.errorMessage =
              res != null ? res.message : "No appsettings data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  profileToFormArray() {
    console.log("profileToFormArray");

    if (this.profiles == null || this.profiles.length == 0) return;

    ///= JSON.parse(JSON.stringify(this.profiles));
    let appSettingsArray = [];
    for (let i = 0; i < this.profiles.length; i++) {
      {
        var profile = this.profiles[i];
        var appSetting = {
          id: "", //new id to be generated later
          organizationid: profile.organizationid,
          profileid: profile.id,
          profilename: profile.name,
          applicationname: "", //to be assigned later while saving the new app
          accessgranted: true,
          defaultapp: false,
          active: true
        };
        appSettingsArray.push(appSetting);
      }
    }

    //merge profile and appsetings on edit mode
    if (
      appSettingsArray.length > 0 &&
      this.mode.toLocaleLowerCase() == "edit"
    ) {
      for (let i = 0; i < appSettingsArray.length; i++) {
        console.log("i", i);
        //compare with the existing appsettings loaded for this application
        for (let j = 0; j < this.appSettingsJSON.length; j++) {
          var item = this.appSettingsJSON[j];

          //compare matching profile
          if (appSettingsArray[i].profileid == item.profileid) {
            console.log("matching found", item.profilename);
            appSettingsArray[i].id = item.id;
            appSettingsArray[i].accessgranted = item.accessgranted;
            appSettingsArray[i].defaultapp = item.defaultapp;
            break;
          }
        }
      }
    }

    //now create FormArray from the list

    //convert profile to appsettings
    if (appSettingsArray != null) {
      //transform json to form controls
      for (let i = 0; i < appSettingsArray.length; i++) {
        var appSet = appSettingsArray[i];

        var fg = new FormGroup({
          id: new FormControl(appSet.id),
          organizationid: new FormControl(appSet.organizationid),
          profileid: new FormControl(appSet.profileid),
          profilename: new FormControl(appSet.profilename),
          applicationname: new FormControl(appSet.applicationname),
          accessgranted: new FormControl(appSet.accessgranted),
          defaultapp: new FormControl(appSet.defaultapp),
          active: new FormControl(appSet.active)
        });

        this.fgsArray.push(fg);
      }

      this.profileForm.setControl("appsettings", new FormArray(this.fgsArray));
    }
  }

  save() {
    this.isLoading = false;
    this.isError = false;
    if (this.detailForm.controls["label"].value.toString().trim() == "") {
      this.showWarning("Application label is mandatory");
      return;
    }
    if (this.detailForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Application name is mandatory");
      return;
    }

    if (this.detailForm.invalid) {
      this.errorMessage = "The fields [Name] and [Label] are mandatory.";
      return;
    }
    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.applicationId = this.guid.getGUID("metaapplication");
    }

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      data: {
        application: {
          mode: this.mode,
          id: this.applicationId,
          label: this.detailForm.controls["label"].value.trim(),
          name: this.detailForm.controls["name"].value.trim(),
          description: this.detailForm.controls["description"].value.trim(),
          standard: true,
          active: this.detailForm.controls["active"].value,
          iconname: this.detailForm.controls["iconname"].value,
          baseurl: this.detailForm.controls["baseurl"].value,
          sinceversionseq:
            this.detailForm.controls["sinceversionseq"].value != null
              ? this.detailForm.controls["sinceversionseq"].value
              : 0,
          deprecatedversionseq:
            this.detailForm.controls["deprecatedversionseq"].value != null
              ? this.detailForm.controls["deprecatedversionseq"].value
              : 0,
          sortorder: this.detailForm.controls["sortorder"].value,
          core: this.detailForm.controls["core"].value,

          appsettings: [],
          applicationlabeltranslation: []
        }
      }
    };

    //get formarray details
    var arrAppSettings = [];
    var arrayControl = this.profileForm.get("appsettings") as FormArray;
    for (let c of arrayControl.controls) {
      var appSetting = {
        id: this.guid.getGUID("appsettings"),
        profileid: c.get("profileid").value,
        profilename: c.get("profilename").value,
        applicationname: this.detailForm.controls["name"].value.trim(),
        accessgranted: c.get("accessgranted").value,
        defaultapp: c.get("defaultapp").value,
        active: true
      };

      //push it to array
      arrAppSettings.push(appSetting);
    }

    //push arrappseting to request data (postoption)
    postOption.data.application.appsettings = arrAppSettings;

    if (this.mode.toLocaleLowerCase() == "edit") {
      var arrtranslatedFields = [];
      for (let translatedapplabel of this.translatedLabels) {
        var applabelTranslation = {
          id: this.guid.getGUID("metaapplicationlabeltranslation"),
          organizationid: localStorage.getItem("crm_orgid"),
          applicationid: this.applicationId,
          languagecode: translatedapplabel.languageCode,
          translatedlabel: translatedapplabel.translatedName,
          active: true
        };

        //push it to array
        arrtranslatedFields.push(applabelTranslation);
      }
      postOption.data.application.applicationlabeltranslation =
        arrtranslatedFields;
    }

    console.log("postOption", postOption);

    this.isLoading = true;
    this.dataService.upsertApplication(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            "/home/applicationdetail/" +
              this.applicationId +
              "/" +
              this.detailForm.controls["name"].value.trim()
          );
        } else {
          console.log("error");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  /*
  getAppSettingsAndMerge(){

    console.log("getAppSettingsAndMerge")

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid:localStorage.getItem("crm_userid"),
      username:localStorage.getItem("crm_username"),
      data: {
        appsettings: {
          appname: this.appName
        }
      }
    }

    this.isLoading = true;
    this.dataService.getAppSettingsByName(postOption).subscribe(
      res => {
        console.log("getAppSettingsByName response",res);
        if(res.success == 1){
          this.appSettingsJSON=res.data.appsettings;
          if(this.profiles != null && this.appSettingsJSON != null)
          {
            //loop through already loaded profile/appsettings formarray
            //var arrayControl = this.profileForm.get('appsettings') as FormArray;
            let arrayControl = this.profileForm.controls['appsettings'] as FormArray;
            for (let i = 0; i < arrayControl.controls.length; i++ ) {
              let c = arrayControl.controls[i];
              //now open retreived appsettings and merge it with already loaded one
              for (let j = 0; j < this.appSettingsJSON.length; j++) {
                var item = this.appSettingsJSON[j];
                //compare matching profile
                if(c.get('profileid').value == item.profileid)
                {
                  console.log("matching", item.profilename);
                  console.log("c", c);

                  var fg = new FormGroup({
                    id: new FormControl(c.get('id').value), //new id to be generated later
                    organizationid: new FormControl(c.get('organizationid').value),
                    profileid: new FormControl(c.get('profileid').value),
                    profilename: new FormControl("hello"),
                    applicationname: new FormControl(c.get('applicationname').value), //to be assigned later while saving the new app

                    accessgranted: new FormControl(item.accessgranted ),
                    defaultapp: new FormControl(item.defaultapp),
                    active: new FormControl(true),
                  });

                 console.log("item.accessgranted", item.accessgranted) ;
                 console.log("item.defaultapp", item.defaultapp) ;
                 console.log("i", i); 
                 arrayControl.at(i).patchValue(fg);
                 //this.profileForm.controls['appsettings'][i] = fg;
                  //c.patchValue(['id','2','3','4','5',false,true]);
                  //c.patchValue(fg);
                  //c.updateValueAndValidity();
                  //console.log("c after", c);
                  break;
                }
              }
            }  

          }
          this.isLoading = false;
        }
        else{
          console.log("error");
          this.errorMessage = res.message;
          this.isError = true;  
          this.isLoading = false;
          //this.resetProfileFormControls();
        }
      },
      err =>{
        console.log("Error***:",err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetProfileFormControls();

      }

    );
  }
*/

  /*
  getProfileAsAppSettings(){
    return new Promise((resolve, reject) => {

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid:localStorage.getItem("crm_userid"),
        username:localStorage.getItem("crm_username"),
        data: {
          profile: {
            userlicense: localStorage.getItem("crm_userlicense")
          }
        }
      }
      console.log("postOption", postOption)
      this.isLoading = true;
      this.dataService.getActiveProfileByUserLicense(postOption).subscribe(      
        res => {
          console.log(res);
          if(res !== null && res.success == 1){
            this.profiles=res.data.profiles;
  
            //convert profile to appsettings
            if(this.profiles != null)
            {
              //transform json to form controls
              for (let i = 0; i < this.profiles.length; i++) {
                var profile = this.profiles[i];
  
                var fg = new FormGroup({
                  id: new FormControl(''), //new id to be generated later
                  organizationid: new FormControl(profile.organizationid),
                  profileid: new FormControl(profile.id),
                  profilename: new FormControl(profile.name),
                  applicationname: new FormControl(''), //to be assigned later while saving the new app
                  accessgranted: new FormControl(true),
                  defaultapp: new FormControl(false),
                  active: new FormControl(true),
                });
  
                this.fgsArray.push(fg);
              }
  
              this.profileForm.setControl('appsettings',new FormArray(this.fgsArray));  
  
            }
            this.isLoading = false;

            resolve();
          }
          else{
            console.log("error");
            this.errorMessage = (res!= null ? res.message : "No profile data!");
            this.isError = true;  
            this.isLoading = false;
            //this.resetProfileFormControls();
            resolve();
          }
        },
        err =>{
          console.log("Error***:",err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          //this.resetProfileFormControls();
          resolve();
        }
  
      );

      
    });
  }

  getProfileAsAppSettings(): Observable<boolean> {
    
    console.log("getProfileAsAppSettings");

    var subject = new Subject<boolean>();
    subject.next(true);

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid:localStorage.getItem("crm_userid"),
      username:localStorage.getItem("crm_username"),
      data: {
        profile: {
          userlicense: localStorage.getItem("crm_userlicense")
        }
      }
    }
    console.log("postOption", postOption)
    this.isLoading = true;
    this.dataService.getActiveProfileByUserLicense(postOption).subscribe(      
      res => {
        console.log(res);
        if(res !== null && res.success == 1){
          this.profiles=res.data.profiles;

          //convert profile to appsettings
          if(this.profiles != null)
          {
            //transform json to form controls
            for (let i = 0; i < this.profiles.length; i++) {
              var profile = this.profiles[i];

              var fg = new FormGroup({
                id: new FormControl(''), //new id to be generated later
                organizationid: new FormControl(profile.organizationid),
                profileid: new FormControl(profile.id),
                profilename: new FormControl(profile.name),
                applicationname: new FormControl(''), //to be assigned later while saving the new app
                accessgranted: new FormControl(true),
                defaultapp: new FormControl(false),
                active: new FormControl(true),
              });

              this.fgsArray.push(fg);
            }

            this.profileForm.setControl('appsettings',new FormArray(this.fgsArray));  

          }
          this.isLoading = false;
        }
        else{
          console.log("error");
          this.errorMessage = (res!= null ? res.message : "No profile data!");
          this.isError = true;  
          this.isLoading = false;
          this.resetProfileFormControls();
        }
      },
      err =>{
        console.log("Error***:",err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        this.resetProfileFormControls();

      }

    );

    console.log("returning subject..");
    return subject.asObservable();
  }
*/
}
